import React from "react";
import BarChart from "./BarChart";
import { useQuery } from "react-query";
import { loanChart } from "services/LoanService";
import { ConfigProvider, Spin } from "antd";

const defaultDistribution = [
  { id: 1, lga: "Yenagoa", loans: 1773 },
  { id: 2, lga: "Sagbama", loans: 1455 },
  { id: 3, lga: "Kolokuma/Opokuma", loans: 551 },
  { id: 4, lga: "Ogbia", loans: 669 },
  { id: 5, lga: "Nembe", loans: 384 },
  { id: 6, lga: "Brass", loans: 354 },
  { id: 7, lga: "Ekeremor", loans: 1152 },
  { id: 8, lga: "Southern Ijaw", loans: 2454 },
];

const ChartsComp = () => {
  // ALWAYS give query a stable key
  const { data, isLoading } = useQuery(["loanDistribution"], loanChart);

  const apiData = data?.data || [];

  // ⏳ LOADING STATE
  if (isLoading) {
    return (
      <>
        <p className="text-lg mb-4 font-poppins text-white font-bold text-center">
          Distribution of Loans by L.G.A
        </p>
        <div className="bg-white p-4 rounded-2xl flex items-center justify-center min-h-[300px]">
          <ConfigProvider
            theme={{
              components: { Spin: { colorPrimary: "rgba(20, 13, 71, 1)" } },
            }}
          >
            <Spin size="large" />
          </ConfigProvider>
        </div>
      </>
    );
  }

  // ❌ NO API DATA → use defaultDistribution only
  const finalDistribution =
    apiData.length === 0
      ? defaultDistribution
      : defaultDistribution.map((item) => {
          const found = apiData.find((x) => x.lga === item.lga);
          return {
            ...item,
            loans: item.loans + (found?.loans || 0),
          };
        });

  // Build chart dataset
  const chartData = {
    labels: finalDistribution.map((d) => d.lga),
    datasets: [
      {
        label: "No. of Loans",
        data: finalDistribution.map((d) => d.loans),
        backgroundColor: "rgba(20, 13, 71, 1)",
      },
    ],
  };

  return (
    <>
      <p className="text-lg mb-4 font-poppins text-white font-bold text-center">
        Distribution of Loans by L.G.A
      </p>
      <div className="bg-white p-4 rounded-2xl min-h-[300px]">
        <BarChart barChartData={chartData} />
      </div>
    </>
  );
};

export default ChartsComp;
